export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10060.cbf14ea6.jpg";